// extracted by mini-css-extract-plugin
export default {"deliveryProposition":"eJMoiA7","title":"jd6VfsM EVhxZk8 leavesden2","description":"kvAFmWt sOoULa1 leavesden4","descriptionLink":"e95khdJ"};